import { useCallback } from "react";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { urlReplacer } from "../../../utils";

export default function () {
  const { request } = useApi();

  return {
    fetchAll: useCallback(
      async (filter, schoolId) => {
        return request({
          method: "GET",
          url: `${urlReplacer(
            ApiRoutes.GET_SCHOOL_STUDENTS + stringify(filter),
            { id: schoolId },
          )}`,
        });
      },
      [request],
    ),

    fetchSchoolStudentsCountries: useCallback(
      (schoolId) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_SCHOOL_STUDENTS_COUNTRIES, {
            id: schoolId,
          })}`,
        });
      },
      [request],
    ),

    fetchSchoolStudentsNames: useCallback(
      (schoolId) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_SCHOOL_STUDENTS_NAMES, {
            id: schoolId,
          })}`,
        });
      },
      [request],
    ),
  };
}
